const tooltips = {
  cegadat: 'A funkció célja, hogy az alkalmazást használó cég székhely / telephely/ fióktelephely adatainak rögzítése, módosítása biztosítva legyen, annak adatai az alkalmazás más moduljaiban felhasználhatók legyenek.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
